import { css } from '@emotion/core';
import theme from '../../themes/default';

const countBarWrapper = css`
  align-items: center;
  display: grid;
  grid-template-columns: min-content min-content 1fr;
  flex-direction: row;
  gap: 8px 16px;
`;

const countBarIcon = css`
  height: 20px;
  width: 20px;
  svg {
    height: 20px;
    width: 20px;
  }
`;

const countBarCount = css`
  color: ${theme.color.designSystem.blackOpacity60};
  font-family: ${theme.font.family.workSans};
  font-size: 14px;
  text-align: center;
`;

const countBar = css`
  display: grid;
  grid-template-columns: min-content min-content 1fr;
  border-radius: 0 ${theme.borderRadius.medium} ${theme.borderRadius.medium} 0;
  height: 8px;
  transition: all 500ms;
`;

export default {
  countBarWrapper,
  countBarIcon,
  countBarCount,
  countBar,
};
